import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-select',
  imports: [ReactiveFormsModule, Select, TranslatePipe, FormsModule],
  templateUrl: './select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ],
  styleUrl: './select.component.scss'
})
export class SelectComponent implements ControlValueAccessor {
  @Input() selectedOption: any;
  @Input() stringTranslate: string = '';
  @Input() placeholder: string = 'Please select';
  @Input() showClear: boolean = true;
  @Input() optionLabel = 'key';
  @Input() optionValue: string = 'value';
  @Input() styleClass: string;
  @Input() invalid: boolean | undefined;
  @Input() disabled: boolean = false;
  @Output() onChangeSelect: EventEmitter<any> = new EventEmitter<any>();

  value: any;
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelect(event: any): void {
    this.onChangeSelect.emit(event);
    this.onChange(event.value);
  }
}
